import * as React from "react";
import {useHistory} from "react-router-dom";

window.history.replaceState({ initial: true }, "");

function useGoBack() {
    const history = useHistory();
    return React.useCallback(() => {
        if (window.history.state.initial) {
            history.replace('/');
        } else {
            history.goBack();
        }
    }, [history]);
}

export default useGoBack;
